<template>
  <div class="paymentError">
    <Header />
    <div uk-height-viewport>
      <div class="uk-flex-center uk-width-auto uk-position-center">
        <img height="350" width="200" src="../assets/payment-error.png" />
        <p class="uk-heading-large uk-text-uppercase uk-text-bold">Erreur !</p>
        <p
          class="uk-text-uppercase uk-text-bold"
        >Une erreur est survenue. Vous n'avez pas été prélevé. Recommencez l'opération.</p>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../components/Header";

export default {
  name: "paymentError",
  components: {
    Header
  },
  mounted() {
    setTimeout(function() {
      window.location.href = "https://checkmy.house";
    }, 3500);
  },

  data() {
    return {};
  },

  methods: {}
};
</script>
